module.exports = {
    meta: {
        version: "1.0",
        service: "trout",
        copyright: "Luca Ventimiglia"
    },
    //api: "http://192.168.0.107:6666/"
   api: "http://localhost:5000/"
   // api: process.env.VUE_APP_API_BASE_URL 

}